import { render, staticRenderFns } from "./taskApprovalBar.vue?vue&type=template&id=304b02ce&"
import script from "./taskApprovalBar.vue?vue&type=script&lang=js&"
export * from "./taskApprovalBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports